
import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  CalendarToday as CalendarIcon
} from '@mui/icons-material';

const FiltrosCierresDiarios = ({ onBuscar, loading }) => {
  const server = process.env.REACT_APP_API_ROUTE;
  
  // Estados de filtros
  const [fechaInicio, setFechaInicio] = useState(() => {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - 30);
    return fecha.toISOString().split('T')[0];
  });
  
  const [fechaFin, setFechaFin] = useState(() => {
    return new Date().toISOString().split('T')[0];
  });
  
  const [idSucursal, setIdSucursal] = useState('');
  const [usuario, setUsuario] = useState('');
  const [sucursales, setSucursales] = useState([]);

  // Cargar sucursales
  useEffect(() => {
    cargarSucursales();
  }, []);

  const cargarSucursales = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${server}/MgSucursales`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Manejar formato .NET con $values
        let sucursalesArray = [];
        
        if (Array.isArray(data)) {
          sucursalesArray = data;
        } else if (data && data.$values && Array.isArray(data.$values)) {
          sucursalesArray = data.$values;
        }
        
        console.log('Sucursales cargadas:', sucursalesArray);
        setSucursales(sucursalesArray);
      }
    } catch (err) {
      console.error('Error al cargar sucursales:', err);
      setSucursales([]);
    }
  };

  const handleBuscar = () => {
    // Validar que la fecha fin no sea menor a la fecha inicio
    if (fechaInicio && fechaFin && new Date(fechaInicio) > new Date(fechaFin)) {
      alert('La fecha fin no puede ser menor a la fecha inicio');
      return;
    }

    const filtros = {
      fechaInicio: fechaInicio ? new Date(fechaInicio) : null,
      fechaFin: fechaFin ? new Date(fechaFin) : null,
      idSucursal: idSucursal && idSucursal !== '' ? Number(idSucursal) : null,
      usuario: usuario.trim() || null
    };

    onBuscar(filtros);
  };

  const handleLimpiar = () => {
    const fechaFinNueva = new Date();
    const fechaInicioNueva = new Date();
    fechaInicioNueva.setDate(fechaInicioNueva.getDate() - 30);
    
    setFechaInicio(fechaInicioNueva.toISOString().split('T')[0]);
    setFechaFin(fechaFinNueva.toISOString().split('T')[0]);
    setIdSucursal('');
    setUsuario('');

    onBuscar({
      fechaInicio: fechaInicioNueva,
      fechaFin: fechaFinNueva,
      idSucursal: null,
      usuario: null
    });
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        {/* Fecha Inicio */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha Inicio"
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarIcon />
                </InputAdornment>
              )
            }}
            disabled={loading}
          />
        </Grid>

        {/* Fecha Fin */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha Fin"
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarIcon />
                </InputAdornment>
              )
            }}
            disabled={loading}
          />
        </Grid>

        {/* Sucursal */}
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth disabled={loading}>
            <InputLabel id="sucursal-label">Sucursal</InputLabel>
            <Select
              labelId="sucursal-label"
              id="sucursal-select"
              value={idSucursal || ''}
              label="Sucursal"
              onChange={(e) => {
                const valor = e.target.value;
                console.log('Evento completo:', e);
                console.log('e.target:', e.target);
                console.log('e.currentTarget:', e.currentTarget);
                console.log('Valor capturado:', valor);
                console.log('Tipo de valor:', typeof valor);
                console.log('Sucursales disponibles:', sucursales);
                setIdSucursal(valor);
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              <MenuItem value="">
                <em>Todas las sucursales</em>
              </MenuItem>
              {Array.isArray(sucursales) && sucursales.length > 0 ? (
                sucursales.map((sucursal) => (
                  <MenuItem key={sucursal.idSucursal} value={sucursal.idSucursal}>
                    {sucursal.nombreSucursal}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>
                  <em>No hay sucursales disponibles</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>

        {/* Usuario/Colaborador */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Usuario/Colaborador"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            placeholder="Buscar por usuario..."
            disabled={loading}
          />
        </Grid>

        {/* Botones */}
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={handleBuscar}
              disabled={loading}
            >
              Buscar
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<ClearIcon />}
              onClick={handleLimpiar}
              disabled={loading}
            >
              Limpiar Filtros
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FiltrosCierresDiarios;
